import AddExpenditure from './AddExpenditure.vue';

export default AddExpenditure;